export default "__VITE_ASSET__Daf8sv5l__"